module.exports = __webpack_public_path__ + "img/humanImg3.ca27d234.png";